import { Link } from "react-router-dom";
import PartnerBanner from "@/components/PartnerBanner";

const LINKS = [
  { label: "Gallery", to: "/", testId: "footer-link-gallery" },
  { label: "Blog", to: "/blog", testId: "footer-link-blog" },
  { label: "About", to: "/about", testId: "footer-link-about" },
  { label: "Privacy Policy", to: "/privacy-policy", testId: "footer-link-privacy" },
  { label: "Contact", to: "/contact", testId: "footer-link-contact" },
];

export default function Footer() {
  return (
    <>
      <PartnerBanner />
      <footer
        data-testid="site-footer"
        className="border-t border-white/10"
      >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-12 grid grid-cols-1 md:grid-cols-[1.4fr_1fr] gap-10">
        <div>
          <Link to="/" className="inline-flex items-baseline">
            <span className="font-display text-xl">
              Prompt<span className="text-[#00E5FF]">Hub</span>
            </span>
          </Link>
          <p className="text-white/50 text-sm mt-3 max-w-md leading-relaxed">
            A free, curated library of professional AI profile photo prompts.
            Built for creators, founders, and anyone tired of generic avatars.
          </p>
          <a
            href="mailto:support@giprompthub.com"
            data-testid="footer-support-email"
            className="mt-4 inline-block text-sm text-white/60 hover:text-[#00E5FF] transition-colors"
          >
            support@giprompthub.com
          </a>
        </div>

        <div>
          <div className="font-mono-label text-white/50">Navigate</div>
          <ul className="mt-4 space-y-2">
            {LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={l.testId}
                  className="text-white/70 hover:text-white transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-5 flex items-center justify-between text-xs">
          <span className="font-mono-label text-white/40">
            © {new Date().getFullYear()} Giprompthub · All rights reserved
          </span>
          <span className="font-mono-label text-white/30 hidden sm:inline">
            giprompthub.com
          </span>
        </div>
      </div>
    </footer>
    </>
  );
}
